import { buildArcadeFieldGoalLiveSequence } from './live-field-goal-arcade.js';

export function buildFieldGoalLiveSequence(context: any): any[] | null {
  if (context.play?.arcadeReplay?.source === 'arcade-sim-v1' && context.play?.arcadePlaybackMode === 'raw') {
    return buildArcadeFieldGoalLiveSequence(context);
  }
  return null;
}
